import React, { Component } from 'react'

import { CrfContext } from "../../CrfContext";

import SideNav from "../sidenav/Sidenav";
import { Link } from 'react-router-dom';

import './ForReview.css'

import axios from 'axios'

export class ForReview extends Component {
    state ={
        approvedRequest: false,
        allRequests: []
    }

    componentDidMount(){
        axios({
            method: 'GET',
            url: `${process.env.REACT_APP_API_KEY}/api/status/forReview`,
            headers: {
              'Api-Key':
                '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
              Authorization: `Bearer ${localStorage.token}`
            }
          })
            .then(response => {
                
              this.setState({
                allRequests: response.data.data
              })
            //     
          })
          .catch(error => {
                
            })
    }



    render() {
        const allRequests = this.state.allRequests
     
        return (
            <CrfContext.Consumer>
      {(context) => (
          <div id="mainPage">
          <div id="sidePanel">
            <SideNav 
              testState = {context.state.testState}
              toggleBtn1List = {context.toggleBtn1List}
              toggleBtn2List = {context.toggleBtn2List}
              btn1List = {context.state.btn1List}
              btn2List = {context.state.btn2List}
              userRole = {context.state.userRole}
            />
          </div>
          <div id="mainPanel">
            <div className="requestSelectionPanel">
                    <div className="toApproveHeader">
                        <div>
                            <h1>For Review</h1>
                        </div>
                        {/* <div className="sortingButtons">
                            <button onClick={this.handleAllRequest}>
                                <span id="allSelected" className="sortBtnInitital">
                                    All Request
                                </span>
                            </button>
                            <button onClick={this.handleApprovedRequest}>
                                <span id="approvedSelected" className="sortBtn">
                                    Approved
                                </span>
                            </button>
                            <button onClick={this.handleTransmittedRequest}>
                                <span id="transmittedSelected" className="sortBtn">
                                    Transmitted
                                </span>
                            </button>
                            <button onClick={this.handleReviewedRequest}>
                                <span id="reviewedSelected" className="sortBtn">
                                    Reviewed
                                </span>
                            </button>
                            <button onClick={this.handleForEndorsementRequest}>
                                <span id="forEndorsementSelected" className="sortBtn">
                                    For Endorsement
                                </span>
                            </button>
                        </div> */}
                        {/* TABLE HEAD */}
                        <div className="myRequestTableHeader">
                            <div className="tHead">
                                <h4>CRF#</h4>
                            </div>
                            <div className="tHead">
                                <h4>Date Created</h4>
                            </div>
                            <div className="tHead">
                                <h6 className="tHeadText">Expected</h6>
                                <h6 className="tHeadText">Completion Date</h6>
                            </div>
                            <div className="tHead">
                                <h4>Amount Requested</h4>
                            </div>
                            <div className="tHead">
                                <h4>Project</h4>
                            </div>
                            <div className="tHead">
                                <h4>Status</h4>
                            </div>
                        </div>
                        {/*END TABLE HEAD */}
                    </div>
                </div>
                {/* TABLE DATA */}
            <div className="divisionToApprove">

            </div>
            {allRequests.map(requestsArray => 
                <Link style={link} to={`/CheckRequest/${requestsArray._id}`}>
                <div className="tableData">
                    <div className="tData">
                        <h4>{requestsArray.crfNo}</h4>
                    </div>
                    <div className="tData">
                        <h4>{(requestsArray.creationDate).slice(4,21)}</h4>
                    </div>
                    <div className="tData">
                        <h4 className="">{requestsArray.expectedCompletionDate ?
                        (requestsArray.expectedCompletionDate).slice(4,21) : '--'}</h4>
                    </div>
                    <div className="tData">
                        <h4><span>&#8369;</span>{(requestsArray.totalNetPrice)
                        .toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</h4>
                    </div>
                    <div className="tData2">
                        <h4>{requestsArray.project.projectName}</h4>
                    </div>
                    <div className="tData">
                        <h4>{requestsArray.status}</h4>
                    </div>
                </div>
            </Link>
            )}
            
            </div>
        </div>

      )}
    </CrfContext.Consumer>
        )
    }
}

const link ={
    textDecoration: "none",
    color: "black"
}

export default ForReview
